module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/particular08-616550082afc69183c6396c0e0224090.png";